// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avneue-no-vendor -> repli-sandbox-avneue-no-vendor -> waterford-trails
// Generated: 2026-10-05T18:31:18.645Z
// Counts: 1 design, 17 content, 22 slot group, 0 collection binding, 3 section, 0 style

export const designOverrides = {
  "design._site.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "VALUE",
    "value": "#0095ff",
    "mappedField": null
  }
};

export const contentOverrides = {
  "apartment-sync.javascript_id": {
    "overrideType": "VALUE",
    "customValue": "asdfasdfasdf",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "110 Royyyyy",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentBlurb": {
    "overrideType": "VALUE",
    "customValue": "Inside, every home is finished for the way you live. Modern chef's kitchens feature stainless steel appliances, granite countertops, and a decorative tile backsplash, while 9-foot ceilings and hardwood-inspired flooring add an airy, upscale feel. Full-size walk-in closets, in-home washer and dryers, and a private patio or balcony complete the comforts of home.",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityBlurb": {
    "overrideType": "VALUE",
    "customValue": "Life at Waterford Trails unfolds beyond your front door. Cool off in the resort-inspired pool, break a sweat in the 24-hour fitness center, or gather friends in the clubhouse and poolside summer kitchen. With woodland nature trails and a dog park just steps away, the best of Spring's outdoors is always within reach.",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitycardgrid.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From the resort-inspired pool to the woodland nature trail, every shared space at Waterford Trails is designed for the way you want to live. Explore the standout features that turn an ordinary day in Spring into something a little more elevated.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Upgraded interiors made for everyday comfort</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Inside, every detail is meant to make home feel effortless. Cook beneath nine-foot ceilings on sleek granite counters with stainless appliances, unwind in a Roman soaking tub after a long day, then tuck the season's wardrobe into a full-size walk-in closet. With a private patio or balcony framing lake and pool views, your apartment feels less like a floor plan and more like a retreat.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.apartmentBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Designed Around You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbSubtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Where Spring's woodlands meet resort living</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbText": {
    "overrideType": "VALUE",
    "customValue": "<p>Step outside and the day is yours: lace up for the nature trail winding through the woodlands, cool off in the resort-inspired pool, or gather friends around the poolside summer kitchen as the Texas evening settles in. Between the clubhouse, the billiards and wine room, and the bark park, Waterford Trails turns shared spaces into the easiest part of your week.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.communityBlurbTitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Room to Roam, Reasons to Gather</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuredamenities.subheading": {
    "overrideType": "VALUE",
    "customValue": "<p>From resort-inspired relaxation to spaces designed for connection, every detail at Waterford Trails is crafted to elevate the way you live. Take a closer look at the amenities that make this community feel like home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.apartment_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Waterford Trails offers thoughtfully designed one, two, and three-bedroom homes in Spring, Texas, each finished with style and comfort in mind. Inside you'll find chef-ready kitchens with granite countertops, stainless steel appliances, and a decorative tile backsplash, plus hardwood-inspired flooring, 9-foot ceilings, full-size walk-in closets, and an in-home washer and dryer. Step out to your private patio or balcony to enjoy the Texas sunshine.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.community_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Life at Waterford Trails is built for connection and relaxation. Cool off in the resort-inspired pool, fire up the poolside summer kitchen, break a sweat in the 24-hour fitness center, or unwind in the clubhouse and billiards lounge—then take the dog to the bark park or wander the community's wooded nature trail. It's an easy, amenity-rich lifestyle just minutes from the shops and festivals of historic Old Town Spring.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.learn_more": {
    "overrideType": "VALUE",
    "customValue": "<p>Waterford Trails offers thoughtfully designed one-, two-, and three-bedroom floor plans from 590 to 1,409 square feet, appointed with stainless steel appliances, granite countertops, full-size washers and dryers, and spacious walk-in closets. Residents enjoy a 24-hour fitness center, a resort-inspired pool with a poolside summer kitchen, a wooded nature trail, a dog park, and a clubhouse with billiards and wine room. Tucked into a vibrant Spring, Texas neighborhood, the community keeps shopping, dining, and recreation just minutes from your door. Schedule a tour today to find the home that fits your life.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.romance_blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Wake up to sunlight spilling across nine-foot ceilings and hardwood-inspired floors, then trade the everyday for a slow morning by the resort-inspired pool. Here in the heart of Spring, Texas, wooded nature trails, an open-air summer kitchen, and thoughtfully finished one-, two-, and three-bedroom homes come together into a rhythm all your own. At Waterford Trails, every corner of the community is designed around the way you want to live.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.intro": {
    "overrideType": "VALUE",
    "customValue": "<p>At Waterford Trails, your furry family members are just as welcome as you are. With our on-site Bark Park and scenic woodlands nature trail, there's plenty of room for your dogs and cats to romp, sniff, and explore right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.featuredAmenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and seating areas."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Inspired Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-9cb5-74cc-bc31-403c0a5f86d7.webp"
      },
      "subtitle": {
        "type": "VALUE",
        "customValue": "Soak up the Texas sunshine in our sparkling resort-style pool, framed by lush landscaping and comfortable lounge seating."
      }
    }
  },
  "amenitycardgrid.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and umbrellas surrounded by lush landscaping."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Inspired Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-11f3-75a3-8635-5319007298fb.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Slip into sparkling waters and stretch out on a sun-soaked lounger surrounded by lush landscaping. It's the kind of poolside afternoon that feels like a getaway, just steps from your front door."
      }
    }
  },
  "amenitycardgrid.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Gym equipment including treadmills, elliptical, rowing machine, and weight machines."
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-0125-768a-9389-41575d799746.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Chase your goals on your own schedule with cardio and strength equipment available around the clock. Squeeze in a sunrise session or an after-work burn without ever leaving home."
      }
    }
  },
  "amenitycardgrid.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor covered patio with grill stations, seating, and a pool in the background."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Poolside Summer Kitchen"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-a2e9-7258-88d9-79476ba04554.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Fire up the grill and gather friends around the open-air summer kitchen as the Texas evening settles in. It's where weeknight dinners become impromptu celebrations beneath the stars."
      }
    }
  },
  "amenitycardgrid.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "A wooden boardwalk leads through trees to a gated pool area with lounge chairs."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Woodlands Nature Trail"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-0b61-7021-9bb9-6c2801f7bb0d.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Lace up and wander the wooded trail winding through the community, where towering trees and quiet paths invite a morning jog or an evening unwind. Nature becomes part of your everyday routine."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6e55-761f-8ae6-d49ad34e03e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with vaulted ceilings, fireplace, and view of kitchen."
      }
    }
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-f4f5-720d-b97e-73f70b936a22.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment building with lush landscaping and blue sky."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-d460-77c4-a7d3-44514e2132c5.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a suburban neighborhood with apartment buildings and a highway."
      }
    }
  },
  "ctasection.card4_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-9cb5-74cc-bc31-403c0a5f86d7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and seating areas."
      }
    }
  },
  "featuredamenities.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Resort-style swimming pool with lounge chairs and seating areas."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resort-Inspired Pool"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-9cb5-74cc-bc31-403c0a5f86d7.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Soak up the sun on a lounge chair or cool off with a midday dip in our resort-inspired pool. It's your private escape for unwinding and gathering with neighbors all season long."
      }
    }
  },
  "featuredamenities.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Fitness center with treadmills, rowing machines, weight machines, and free weights."
      },
      "title": {
        "type": "VALUE",
        "customValue": "24-Hour Fitness Center"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-9981-776f-9f9c-e022a51bff24.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Stay on top of your goals on your own schedule in our modern 24-hour fitness center, stocked with cardio and strength equipment. A great workout is always just steps from your door."
      }
    }
  },
  "featuredamenities.card_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Stylish lounge area with modern furniture, coffee station, and high ceilings."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Resident Clubhouse"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-f6d3-746c-b2c4-583d27014b79.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Gather with friends or settle in for a quiet afternoon in our stylish clubhouse, complete with a coffee bar and comfortable seating. It's the perfect spot to relax, socialize, or get a little work done."
      }
    }
  },
  "featuredamenities.card_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two stainless steel grills, granite countertops, stone accents, and seating by the pool."
      },
      "title": {
        "type": "VALUE",
        "customValue": "Poolside Outdoor Kitchen"
      },
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-b37c-75fb-991f-7c018b76651c.webp"
      },
      "description": {
        "type": "VALUE",
        "customValue": "Fire up the grills and dine al fresco at our poolside summer kitchen, made for weekend cookouts and easy evenings outdoors. It's effortless entertaining in the heart of the community."
      }
    }
  },
  "gallery.hero_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-2259-75f4-a547-27b2243eefa4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinetry."
      }
    }
  },
  "gallery.hero_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-6e55-761f-8ae6-d49ad34e03e6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Spacious living room with vaulted ceilings, fireplace, and view of kitchen."
      }
    }
  },
  "gallery.hero_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-b37c-75fb-991f-7c018b76651c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two stainless steel grills, granite countertops, stone accents, and seating by the pool."
      }
    }
  },
  "petpolicy.feature_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-ae11-737a-b0a6-189e039a0797.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Fenced dog park area with green grass and trees."
      }
    }
  },
  "petpolicy.lifestyle_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfde0-46be-70de-a044-22137d8c9e47.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of apartment buildings with lush green lawns and palm trees."
      }
    }
  },
  "propertyoverview.feature_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-8c66-7444-aa6a-5064995dd134.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with a blue sofa, two gray armchairs, a coffee table, dining table and chairs, and a kitchen counter with bar stools."
      }
    }
  },
  "propertyoverview.feature_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-5427-70a8-85ee-e83a48503a18.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry."
      }
    }
  },
  "propertyoverview.feature_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019cfddf-d0e6-748f-ace5-a8fb114ad71e.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "King size bed with blue and white bedding and pillows, navy accent wall, dresser, and chair."
      }
    }
  },
  "propertyoverview.feature_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449162945/019d4e8c-b37c-75fb-991f-7c018b76651c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor grilling area with two stainless steel grills, granite countertops, stone accents, and seating by the pool."
      }
    }
  }
};

export const collectionBindingOverrides = {};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    }
  ],
  "floor-plans": [
    {
      "sectionId": "apartment-sync",
      "blockId": "apartment-sync",
      "position": 3
    }
  ]
};

export const styleOverrides = {};
